import React, {useEffect} from "react";
import useDataTheme, {_theme_event as themeChange} from "../../hooks/UseDataTheme";
import './KofiButton.scss';
import CommonProps from "../CommonProps";

const KofiButton = (props: CommonProps) => {

    const [theme] = useDataTheme();
    const [value, setValue] = React.useState<string>(theme);
    const [key, setKey] = React.useState<number>(0);

    useEffect(() => {
        window.addEventListener(themeChange, (e: Event) => {
            const ce = e as CustomEvent<string>;
            const theme = ce.detail;
            if (theme) {
                setValue(theme);
                setKey(key + 1);
            }
        });
    }, []);

    return (
        <>
            <a href='https://ko-fi.com/R5R06FLC8'
               target='_blank'
               rel="noopener noreferrer">
                <img key={`kofi-button-${key}`}
                     className={`kofi-button ${props.className ? props.className : ''}`}
                     src={`https://storage.ko-fi.com/cdn/kofi${value === 'dark' ? 3 : 6}.png?v=6&k=${key}`}
                     alt='Buy Me a Coffee at ko-fi.com'
                     title='Buy me a Ko-fi!'/>
            </a>
        </>
    );
}

export default KofiButton;